import { useCallback, useMemo, useReducer } from 'react';
import { actions, INITIAL_STATE, reducer } from './reducers/promo_codes';

export default () => {
  const [promoCodesData, dispatch] = useReducer(reducer, INITIAL_STATE);

  const loadPromoCodes = useCallback(
    params => {
      return actions.loadPromoCodes(dispatch, params);
    },
    [dispatch],
  );
  const loadPromoCode = useCallback(
    params => {
      return actions.loadPromoCode(dispatch, params);
    },
    [dispatch],
  );
  const createPromoCode = useCallback(
    params => {
      return actions.createPromoCode(dispatch, params);
    },
    [dispatch],
  );
  const updatePromoCode = useCallback(
    params => {
      return actions.updatePromoCode(dispatch, params);
    },
    [dispatch],
  );
  const promoCodesActions = useMemo(
    () => ({
      loadPromoCodes,
      loadPromoCode,
      createPromoCode,
      updatePromoCode,
    }),
    [loadPromoCodes, loadPromoCode, createPromoCode, updatePromoCode],
  );
  return useMemo(() => ({ promoCodesData, promoCodesActions }), [promoCodesData, promoCodesActions]);
};
